module.exports = __webpack_public_path__ + "media/img/avata-duck-cd48a4b3.png";